module.exports = __webpack_public_path__ + "img/9788979868616.0fd6cf5b.jpg";